import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Home from './pages/Home';
import Jobs from './pages/Jobs';
import JobDetails from './pages/JobDetails';
import SavedJobs from './pages/SavedJobs';
import About from './pages/About';
import Contact from './pages/Contact';
import JobLogin from './pages/job-login';
import JobSignup from './pages/job-signup';

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/:jobId" element={<JobDetails />} />
          <Route path="/saved-jobs" element={<SavedJobs />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/job-login" element={<JobLogin />} />
          <Route path="/job-signup" element={<JobSignup />} />
        </Routes>
        
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          theme="dark"
          toastStyle={{
            background: 'var(--charcoal)',
            color: 'var(--pearl)',
            border: '1px solid rgba(212, 175, 55, 0.2)'
          }}
        />
      </div>
    </Router>
  );
}

export default App;
